<script>
  import Dropdown from "@components/shared/dropdown.svelte";
  import { ChevronDown, Calendar } from 'lucide-svelte'
  import { setDateRange } from "@lib/date-utils";
  
  // Options can be true, future, past
  let { options = true, onChange } = $props();

</script>

<Dropdown buttonClass="button bg-transparent h-[40px] flex items-center justify-center">
  {#snippet contents(item)}

    {@render item({ text: "Effacer", icon: Calendar, onSelect: () => onChange?.(["", ""]) })}
    
    {@render item({ text: "Aujourd'hui", icon: Calendar, onSelect: () => onChange?.(setDateRange.today()) })}
    {#if options !== "future"}
      {@render item({ text: "Hier", icon: Calendar, onSelect: () => onChange?.(setDateRange.yesterday()) })}
    {/if}
    {#if options !== "past"}
      {@render item({ text: "Demain", icon: Calendar, onSelect: () => onChange?.(setDateRange.tomorrow()) })}
    {/if}

    {@render item({ text: "Cette semaine", icon: Calendar, onSelect: () => onChange?.(setDateRange.thisWeek()) })}
    {@render item({ text: "Jusqu'à la fin de la semaine", icon: Calendar, onSelect: () => onChange?.(setDateRange.tilEndOfWeek()) })}
    {#if options !== "future"}
      {@render item({ text: "La semaine dernière", icon: Calendar, onSelect: () => onChange?.(setDateRange.lastWeek()) })}
    {/if}
    {#if options !== "past"}
      {@render item({ text: "La semaine prochaine", icon: Calendar, onSelect: () => onChange?.(setDateRange.nextWeek()) })}
    {/if}

    {@render item({ text: "Ce mois-ci", icon: Calendar, onSelect: () => onChange?.(setDateRange.thisMonth()) })}
    {@render item({ text: "Jusqu'à la fin du mois", icon: Calendar, onSelect: () => onChange?.(setDateRange.tilEndOfMonth()) })}
    {#if options !== "future"}
      {@render item({ text: "Le mois dernier", icon: Calendar, onSelect: () => onChange?.(setDateRange.lastMonth()) })}
    {/if}
    {#if options !== "past"}
      {@render item({ text: "Le mois prochain", icon: Calendar, onSelect: () => onChange?.(setDateRange.nextMonth()) })}
    {/if}

    {@render item({ text: "Cette année", icon: Calendar, onSelect: () => onChange?.(setDateRange.thisYear()) })}
    {@render item({ text: "Jusqu'à la fin de l'année", icon: Calendar, onSelect: () => onChange?.(setDateRange.tilEndOfYear()) })}
    {#if options !== "future"}
      {@render item({ text: "L'année dernière", icon: Calendar, onSelect: () => onChange?.(setDateRange.lastYear()) })}
    {/if}
    {#if options !== "past"}
      {@render item({ text: "L'année prochaine", icon: Calendar, onSelect: () => onChange?.(setDateRange.nextYear()) })}
    {/if}
    {#if options !== "future"}
      {@render item({ text: "Dans le passé", icon: Calendar, onSelect: () => onChange?.(setDateRange.past()) })}
    {/if}
    {#if options !== "past"}
      {@render item({ text: "Dans le futur", icon: Calendar, onSelect: () => onChange?.(setDateRange.future()) })}
    {/if}

  {/snippet}
</Dropdown>